import { render, staticRenderFns } from "./RPAscheme.vue?vue&type=template&id=2c6e9fd3&scoped=true"
import script from "./RPAscheme.vue?vue&type=script&lang=js"
export * from "./RPAscheme.vue?vue&type=script&lang=js"
import style0 from "./RPAscheme.vue?vue&type=style&index=0&id=2c6e9fd3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6e9fd3",
  null
  
)

export default component.exports